/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Stats_NoneInputs */

const th_player_stats_none = /** @type {(inputs: Player_Stats_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีการบันทึกสถิติของผู้เล่นคนนี้`)
};

const en_player_stats_none = /** @type {(inputs: Player_Stats_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No box score has been kept for this player yet.`)
};

const ja_player_stats_none = /** @type {(inputs: Player_Stats_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この選手のスタッツはまだ記録されていません。`)
};

const zh_player_stats_none = /** @type {(inputs: Player_Stats_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未为这名球员记录任何数据。`)
};

const es_player_stats_none = /** @type {(inputs: Player_Stats_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no se han registrado estadísticas de este jugador.`)
};

const pt_player_stats_none = /** @type {(inputs: Player_Stats_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma estatística foi registrada para este jogador ainda.`)
};

const id_player_stats_none = /** @type {(inputs: Player_Stats_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada statistik yang dicatat untuk pemain ini.`)
};

const fr_player_stats_none = /** @type {(inputs: Player_Stats_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune feuille de match n’a encore été tenue pour ce joueur.`)
};

const tl_player_stats_none = /** @type {(inputs: Player_Stats_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang naitalang istatistika para sa manlalarong ito.`)
};

const vi_player_stats_none = /** @type {(inputs: Player_Stats_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa ghi nhận thống kê nào cho cầu thủ này.`)
};

const ko_player_stats_none = /** @type {(inputs: Player_Stats_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 선수의 기록이 아직 없습니다.`)
};

const de_player_stats_none = /** @type {(inputs: Player_Stats_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für diesen Spieler wurde noch keine Statistik geführt.`)
};

const ru_player_stats_none = /** @type {(inputs: Player_Stats_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`По этому игроку статистика ещё не велась.`)
};

const tr_player_stats_none = /** @type {(inputs: Player_Stats_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu oyuncu için henüz istatistik tutulmadı.`)
};

const it_player_stats_none = /** @type {(inputs: Player_Stats_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna statistica ancora registrata per questo giocatore.`)
};

const pl_player_stats_none = /** @type {(inputs: Player_Stats_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dla tego zawodnika nie prowadzono jeszcze statystyk.`)
};

const uk_player_stats_none = /** @type {(inputs: Player_Stats_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для цього гравця статистику ще не вели.`)
};

const hi_player_stats_none = /** @type {(inputs: Player_Stats_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस खिलाड़ी के लिए अभी कोई आँकड़े दर्ज नहीं हुए।`)
};

const ar_player_stats_none = /** @type {(inputs: Player_Stats_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم تُسجَّل إحصاءات لهذا اللاعب بعد.`)
};

const ms_player_stats_none = /** @type {(inputs: Player_Stats_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada statistik direkodkan untuk pemain ini.`)
};

const bn_player_stats_none = /** @type {(inputs: Player_Stats_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই খেলোয়াড়ের জন্য এখনও কোনও পরিসংখ্যান রাখা হয়নি।`)
};

const zh_tw2_player_stats_none = /** @type {(inputs: Player_Stats_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未為這位球員記錄任何數據。`)
};

const zh_hk2_player_stats_none = /** @type {(inputs: Player_Stats_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未為這位球員記錄任何數據。`)
};

const ur_player_stats_none = /** @type {(inputs: Player_Stats_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اس کھلاڑی کے لیے ابھی کوئی اعداد و شمار نہیں رکھے گئے۔`)
};

const fa_player_stats_none = /** @type {(inputs: Player_Stats_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هنوز آماری برای این بازیکن ثبت نشده است.`)
};

const sw_player_stats_none = /** @type {(inputs: Player_Stats_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna takwimu zilizorekodiwa kwa mchezaji huyu bado.`)
};

const nl_player_stats_none = /** @type {(inputs: Player_Stats_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voor deze speler is nog geen statistiek bijgehouden.`)
};

/**
* | output |
* | --- |
* | "No box score has been kept for this player yet." |
*
* @param {Player_Stats_NoneInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const player_stats_none = /** @type {((inputs?: Player_Stats_NoneInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Stats_NoneInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_player_stats_none(inputs)
	if (locale === "ja") return ja_player_stats_none(inputs)
	if (locale === "zh") return zh_player_stats_none(inputs)
	if (locale === "es") return es_player_stats_none(inputs)
	if (locale === "pt") return pt_player_stats_none(inputs)
	if (locale === "id") return id_player_stats_none(inputs)
	if (locale === "fr") return fr_player_stats_none(inputs)
	if (locale === "tl") return tl_player_stats_none(inputs)
	if (locale === "vi") return vi_player_stats_none(inputs)
	if (locale === "ko") return ko_player_stats_none(inputs)
	if (locale === "de") return de_player_stats_none(inputs)
	if (locale === "ru") return ru_player_stats_none(inputs)
	if (locale === "tr") return tr_player_stats_none(inputs)
	if (locale === "it") return it_player_stats_none(inputs)
	if (locale === "pl") return pl_player_stats_none(inputs)
	if (locale === "uk") return uk_player_stats_none(inputs)
	if (locale === "hi") return hi_player_stats_none(inputs)
	if (locale === "ar") return ar_player_stats_none(inputs)
	if (locale === "ms") return ms_player_stats_none(inputs)
	if (locale === "bn") return bn_player_stats_none(inputs)
	if (locale === "zh-TW") return zh_tw2_player_stats_none(inputs)
	if (locale === "zh-HK") return zh_hk2_player_stats_none(inputs)
	if (locale === "ur") return ur_player_stats_none(inputs)
	if (locale === "fa") return fa_player_stats_none(inputs)
	if (locale === "sw") return sw_player_stats_none(inputs)
	if (locale === "nl") return nl_player_stats_none(inputs)
	return en_player_stats_none(inputs)
});